import { Layout } from "antd";
import React from "react";

const { Content } = Layout;

type FullScreenViewProps = {
  children: React.ReactNode;
  width?: string;
  alignItems?: string;
  style?: React.CSSProperties;
  header: React.ReactNode;
  footer: React.ReactNode;
};

const FullScreenView = ({
  children,
  width = "400px",
  alignItems = "center",
  style,
  header,
  footer,
}: FullScreenViewProps) => {
  return (
    <Layout className="full_screen">
      {header}
      <Content
        className="full_screen__content"
        style={{ alignItems: alignItems }}
      >
        <div
          className="full_screen__content__inner"
          style={{
            maxWidth: width,
            ...style,
          }}
        >
          {children}
        </div>
      </Content>
      {footer}
    </Layout>
  );
};

export default FullScreenView;
